'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ACTIONS = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case 'RESET':
      return initialState;
    case constants.UPDATE_ACCOUNT_SUCCESS:
      {
        return (0, _qim.update)(['accountData', (0, _qim.$merge)((0, _get3.default)(action, 'result.data', {}))], reducer(state, action));
      }
    case constants.MAKE_EMAIL_PRIMARY_SUCCESS:
    case constants.DELETE_EMAIL_SUCCESS:
      return (0, _extends3.default)({}, reducer(state, action), {
        userEmailsData: action.result.data
      });
    default:
      return reducer(state, action);
  }
};

exports.isLoaded = isLoaded;
exports.isLoadTime = isLoadTime;
exports.loadAccount = loadAccount;
exports.loadUserEmails = loadUserEmails;
exports.addEmail = addEmail;
exports.deleteEmail = deleteEmail;
exports.makeEmailPrimary = makeEmailPrimary;
exports.updatePassword = updatePassword;
exports.addEmailConfirm = addEmailConfirm;
exports.updateAccount = updateAccount;

var _qim = require('qim');

var _loadReducer = require('../loadReducer');

var _loadReducer2 = _interopRequireDefault(_loadReducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Account redux reducer and action creators */

var loadReducer = (0, _loadReducer2.default)('account', {
  account: { action: 'load', init: null },
  userEmails: { action: 'load', init: null },
  addEmail: { init: null },
  deleteEmail: { init: null },
  makeEmailPrimary: { init: null },
  updatePassword: { init: null },
  addEmailConfirm: { init: null },
  updateAccount: {}
});

var initialState = (0, _extends3.default)({}, loadReducer.initialState);

var constants = loadReducer.constants,
    reducer = loadReducer.reducer,
    constantsByKey = loadReducer.constantsByKey;
var ACTIONS = exports.ACTIONS = constants;

function isLoaded(globalState) {
  return (0, _get3.default)(globalState, 'account.loaded', false);
}

function isLoadTime(globalState) {
  return !isLoaded(globalState) && (0, _get3.default)(globalState, 'auth.authKey', false);
}

function loadAccount() {
  return {
    types: constantsByKey.account,
    promise: function promise(client) {
      return client.post('users_wa/account');
    }
  };
}

function loadUserEmails() {
  return {
    types: constantsByKey.userEmails,
    promise: function promise(client) {
      return client.post('users_wa/getUserEmails');
    }
  };
}

function addEmail(email) {
  return {
    types: constantsByKey.addEmail,
    promise: function promise(client) {
      return client.post('users_wa/addEmail', { data: { email: email } });
    },
    email: email
  };
}

function deleteEmail(email) {
  return {
    types: constantsByKey.deleteEmail,
    promise: function promise(client) {
      return client.post('users_wa/removeEmail', { data: { email: email } });
    },
    email: email
  };
}

function makeEmailPrimary(email) {
  return {
    types: constantsByKey.makeEmailPrimary,
    promise: function promise(client) {
      return client.post('users_wa/makePrimary', { data: { email: email } });
    },
    email: email
  };
}

function updatePassword(newPassword, currentPassword) {
  return {
    types: constantsByKey.updatePassword,
    promise: function promise(client) {
      return client.post('users_wa/updatePassword', { data: { newPassword: newPassword, currentPassword: currentPassword } });
    },
    newPassword: newPassword,
    currentPassword: currentPassword
  };
}

function addEmailConfirm(key, code) {
  return {
    types: constantsByKey.addEmailConfirm,
    promise: function promise(client) {
      return client.post('auth/addEmailKeyCheck', { data: { key: key, code: code } });
    },
    key: key,
    code: code
  };
}

function updateAccount(_ref) {
  var firstName = _ref.firstName,
      lastName = _ref.lastName;

  return function (dispatch, getState) {
    var _getState$account$acc = getState().account.accountData,
        accountData = _getState$account$acc === undefined ? {} : _getState$account$acc;

    var data = {
      firstName: firstName || accountData.firstName,
      lastName: lastName || accountData.lastName
    };

    return dispatch({
      types: constantsByKey.updateAccount,
      promise: function promise(client) {
        return client.post('users_wa/editAccount', { data: data });
      },
      firstName: firstName,
      lastName: lastName
    });
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/account.js
// module id = 184
// module chunks = 1